import { datadogRum } from "@datadog/browser-rum";
import { nextjsPlugin, onRouterTransitionStart } from "@datadog/browser-rum-nextjs";

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || "";
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "";
const env = process.env.NEXT_PUBLIC_VERCEL_CUSTOM_ENV || "";
const service = process.env.NEXT_PUBLIC_DATADOG_RUM_SERVICE || "";
const version = (
  process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID || ""
).toLowerCase();

if (applicationId && clientToken && env && service && version) {
  const tracingUrls = [
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_VERCEL_URL
      ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
      : undefined,
    process.env.NEXT_PUBLIC_APP_URL,
  ].filter(Boolean);

  datadogRum.init({
    allowedTracingUrls: tracingUrls.map((url) => ({
      match: url as string,
      propagatorTypes: ["datadog", "tracecontext"] as const,
    })),
    applicationId,
    clientToken,
    defaultPrivacyLevel: "allow",
    env,
    service,
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    silentMultipleInit: true,
    site: "datadoghq.com",
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    version,
    plugins: [nextjsPlugin()],
  });
}

export { onRouterTransitionStart };
